module.exports = __webpack_public_path__ + "img/js.430c8790.jpg";